import { useApiQuery } from './useApiQuery';
import { fetchApi } from '../lib/api/client';

interface CurrentUser {
  id: string;
  email: string;
  name: string;
  avatarUrl?: string;
}

/**
 * Resolves the internal database user ID for the currently signed-in Clerk user.
 * Uses the existing /users/me endpoint which maps Clerk ID -> internal user.
 *
 * Cached aggressively (5 min) since the current user rarely changes within a session.
 */
export function useCurrentUser() {
  return useApiQuery<CurrentUser>({
    queryKey: ['current-user'],
    queryFn: (token) => fetchApi<CurrentUser>('/users/me', { token }),
    staleTime: 5 * 60 * 1000,
  });
}
